import { AppBar, Button, Dialog, Grid, IconButton, makeStyles, Toolbar, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { deepClone } from "../../helpers/objectHelper";
import CloseIcon from "@material-ui/icons/Close";
import Select from "react-select";
import Slide from "@material-ui/core/Slide";
import { EventLayoutList } from "./components/EventLayoutList";
import { PresetList } from "./components/PresetList";
import Axios from "axios";
import AddIcon from "@material-ui/icons/Add";
import SaveIcon from "@material-ui/icons/Save";
import SystemLabel from "../../system/SystemLabel/SystemLabel";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  paper: {
    overflow: "hidden",
  },
}));

export const Preset = (props) => {
  const [presets, setPresets] = useState([]);
  const [activeEventLayouts, setActiveEventLayouts] = useState([]);
  const [events, setEvents] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [changedPresets, setChangedPresets] = useState([]);
  const [changedPresetItems, setChangedPresetItems] = useState([]);
  const [isSavable, setSavable] = useState(false);
  const classes = useStyles();
  const { hubConnection, eventId, connected } = props;

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    if (hubConnection && connected) {
      hubConnection.on("onGetPresets", (res) => {
        setPresets(res);
      });
      hubConnection.on("onGetActiveEventLayouts", (res) => {
        setActiveEventLayouts(res);
      });
      hubConnection.on("onPresetActivated", (res) => {
        setActiveEventLayouts(res);
      });
      hubConnection.on("onGetEvents", (res) => {
        setEvents(res);
      });
   
      hubConnection.invoke("getPresets", eventId);
      hubConnection.invoke("getActiveLayouts", eventId);
      hubConnection.invoke("getEvents", eventId);
      Axios.get(`./api/meeting/layouts/${eventId}`).then(({ data }) => {
        setLayouts(data);
      });
    }
  };

  const onEditPreset = (presetId, name) => {
    const index = presets.indexOf(presets.find((p) => p.daPresetId == presetId));

    if (index < 0) return;

    const modifiedPresets = deepClone(presets);
    modifiedPresets[index].name = name;

    setPresets(modifiedPresets);

    modifiedPresets[index].edited = true;

    const modifiedChangePresets = deepClone(changedPresets);
    const changePresetIndex = modifiedChangePresets.indexOf(modifiedChangePresets.find((c) => c.daPresetId == presetId));

    if (changePresetIndex > -1) {
      modifiedChangePresets[changePresetIndex].name = name;
    } else {
      setChangedPresets([...modifiedChangePresets, modifiedPresets[index]]);
    }
    setSavable(true);
  };
  const sortPresets = () => {};

  const addPreset = () => {
    const newId = changedPresets.filter((p) => p.added == true).length;
    const newPreset = {
      daPresetId: newId == 0 ? -1 : newId + 1 * -1,
      name: "",
      inserted: new Date(),
      eventId: 0,
      sortOrder: 0,
      daPresetItems: [],
      added: true,
    };

    const modifiedPresets = deepClone(presets);

    modifiedPresets.push(newPreset);

    setPresets(modifiedPresets);
    setChangedPresets([...changedPresets, newPreset]);
    setSavable(true);
  };

  const deletePreset = (presetId) => {
    const deletedPreset = presets.find((p) => p.daPresetId == presetId);
    if (!deletedPreset) return;

    deletedPreset.deleted = true;
    let modifiedPresets = deepClone(presets);
    modifiedPresets = modifiedPresets.filter((m) => m.daPresetId != presetId);

    setChangedPresets([...changedPresets.filter((cp) => cp.daPresetId != presetId), deletedPreset]);
    setPresets(modifiedPresets);
    setSavable(true);
  };

  const deletePresetItem = (presetItemId) => {
    const parentPreset = presets.find((p) => p.daPresetItems.find((pp) => pp.daPresetItemId == presetItemId));
    if (!parentPreset) return;

    let deletedPresetItem = parentPreset.daPresetItems.find((p) => p.daPresetItemId == presetItemId);

    if (!deletedPresetItem) return;

    deletedPresetItem.deleted = true;

    setChangedPresetItems([...changedPresetItems.filter((cp) => cp.daPresetItemId != presetItemId), deletedPresetItem]);

    const modifiedPresets = deepClone(presets);
    const index = presets.indexOf(presets.find((p) => p.daPresetId == deletedPresetItem.daPresetId));

    if (index < 0) return;

    modifiedPresets[index].daPresetItems = modifiedPresets[index].daPresetItems.filter((pi) => pi.daPresetItemId != presetItemId);
    setPresets(modifiedPresets);
    setSavable(true);
  };
  const addPresetItem = (eventId, layoutId, presetId) => {
    const index = presets.indexOf(presets.find((p) => p.daPresetId == presetId));
    if (index < 0) return;

    const modifiedPresets = deepClone(presets);
    const newId = changedPresetItems.filter((p) => p.added == true).length;
    const newPresetItem = {
      daPresetItemId: newId == 0 ? -1 : newId + 1 * -1,
      targetEventId: eventId,
      meetingLayoutId: layoutId,
      daPresetId: presetId,
      added: true,
    };

    modifiedPresets[index].daPresetItems.push(newPresetItem);

    setPresets(modifiedPresets);
    setChangedPresetItems([...changedPresetItems, newPresetItem]);
    setSavable(true);
  };

  const activatePreset = (presetId) => {
    if (hubConnection && connected && presetId) {
      hubConnection.invoke("activatePreset", presetId);
    } else {
      alert("NO CONNECTION - RELOAD PAGE");
    }
  };

  const savePresets = () => {
    if (hubConnection && connected) {
      changedPresets.map((cl) => {
        if (cl.added && cl.deleted) {
        } else if (cl.added) {
          cl.status = "added";
        } else if (cl.deleted) {
          cl.status = "deleted";
        } else {
          cl.status = "updated";
        }
        delete cl.edited;
        delete cl.deleted;
        delete cl.added;
      });

      changedPresetItems.map((cl) => {
        if (cl.added && cl.deleted) {
        } else if (cl.added) {
          cl.status = "added";
        } else if (cl.deleted) {
          cl.status = "deleted";
        } else {
          cl.status = "updated";
        }
        delete cl.edited;
        delete cl.deleted;
        delete cl.added;
      });
      hubConnection.invoke("addOrUpdatePresets", eventId, { presets: changedPresets, presetItems: changedPresetItems });
      setSavable(false);
    } else {
      alert("NO CONNECTION - RELOAD PAGE");
    }
  };

  const activateLayout = (eventId, layoutId) => {
    if (hubConnection && connected && eventId && layoutId) {
      hubConnection.invoke("activateLayout", eventId, layoutId);
    } else {
      alert("NO CONNECTION - RELOAD PAGE");
    }
  };

  const addOrInsertPreset = () => {};

  const api = {
    ...props,
    activateLayout,
    activeEventLayouts,
    presets,
    savePresets,
    activatePreset,
    addPreset,
    events,
    layouts,
    isSavable,
    onEditPreset,
    deletePreset,
    deletePresetItem,
    addPresetItem,
    sortPresets,
  };
  return (
    <Dialog scroll={"body"} classes={classes} fullScreen open={true} onClose={() => null} TransitionComponent={Transition}>
      <AppBar className={classes.appBar + " dark-l0"} style={{padding: '0px 15px'}}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={props.close} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Button startIcon={<AddIcon />} className="secondary-dark-btn" style={{ marginRight: 5 }} onClick={() => addPreset()}>
            <SystemLabel name="Preset" />
          </Button>
          <Button disabled={!isSavable} startIcon={<SaveIcon />} className="primary-dark-btn" onClick={() => savePresets()}>
            <SystemLabel name="Save" />
          </Button>
        </Toolbar>
      </AppBar>
      <Grid style={{ height: "100%", padding: 24 }} className="dark-l1" container spacing={2}>
        <Grid item xs={6} /* style={{ padding: "16px 24px" }} */>
          <PresetList {...api} />
        </Grid>
        <Grid item xs={6} /* style={{ padding: "16px 24px" }} */>
          <EventLayoutList {...api} />
        </Grid>
      </Grid>
    </Dialog>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
